interface Config {
  apiEndpoint: string | undefined;
  awsRegion: string | undefined;
  userPoolId: string | undefined;
  userPoolClientId: string | undefined;
  userPoolDomain: string | undefined;
  signInUrl: string | undefined;
  signOutUrl: string | undefined;
}

declare global {
  interface Window {
    config: Config;
  }
}

const configDefault:Config = {
  apiEndpoint: process.env.REACT_APP_SSO_API_ENDPOINT,
  awsRegion: process.env.REACT_APP_AMPLIFY_AUTH_AWS_REGION,
  userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_AWS_POOL_ID,
  userPoolClientId: process.env.REACT_APP_AMPLIFY_AUTH_AWS_WEB_CLIENT_ID,
  userPoolDomain: process.env.REACT_APP_AMPLIFY_AUTH_DOMAIN,
  signInUrl: process.env.REACT_APP_AMPLIFY_AUTH_REDIRECT_SIGN_IN,
  signOutUrl: process.env.REACT_APP_AMPLIFY_AUTH_REDIRECT_SIGN_OUT
};

function useConfig():Config {
  return { ...configDefault, ...JSON.parse(JSON.stringify(window.config)) } as Config;
}

export default useConfig;
